import { render, staticRenderFns } from "./FulfillmentKomshipCard.vue?vue&type=template&id=95158b9e&"
import script from "./FulfillmentKomshipCard.vue?vue&type=script&lang=js&"
export * from "./FulfillmentKomshipCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports